import {
  IMessagingSettings,
  IMessagingSettingsSave,
} from '@dataTypes/messaging-settings.type'
import {
  fetchMessagingSettingsByClinicApi,
  saveMessagingSettingsApi,
} from '@services/api/messaging-settings.api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '@store/index'

export const fetchMessagingSettingsByClinic = createAsyncThunk<
  IMessagingSettings[],
  void,
  { rejectValue: string; state: RootState }
>('api/settings/messaging/fetch', async (_, { getState, rejectWithValue }) => {
  const clinicId = getState().clinic.selectedClinic?.clinic_id
  if (!clinicId) return rejectWithValue('No clinic selected')
  try {
    const res = await fetchMessagingSettingsByClinicApi(clinicId)
    if (res.statusCode !== 200) {
      return rejectWithValue(res.message || 'Failed to load messaging settings')
    }
    return res.data?.messaging_settings ?? []
  } catch {
    return rejectWithValue('Failed to load messaging settings')
  }
})

export const saveMessagingSettings = createAsyncThunk<
  IMessagingSettings,
  IMessagingSettingsSave & { updated_by?: string | null },
  { rejectValue: string }
>('api/settings/messaging/save', async (payload, { rejectWithValue }) => {
  try {
    const res = await saveMessagingSettingsApi(payload)
    if (res.statusCode !== 200 || !res.data?.messaging_settings) {
      return rejectWithValue(res.message || 'Failed to save messaging settings')
    }
    return res.data.messaging_settings
  } catch (e: unknown) {
    const message =
      e &&
      typeof e === 'object' &&
      'response' in e &&
      (e as { response?: { data?: { message?: string } } }).response?.data
        ?.message
    return rejectWithValue(
      typeof message === 'string'
        ? message
        : 'Failed to save messaging settings',
    )
  }
})
